import { jsx as l, jsxs as e } from "react/jsx-runtime";
function h(a) {
  return /* @__PURE__ */ l("svg", { height: "1em", viewBox: "0 0 24 24", width: "1em", ...a, children: /* @__PURE__ */ e("g", { fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ l("path", { d: "M4 4h16v16H4z" }),
    /* @__PURE__ */ l(
      "path",
      {
        d: "M17.656 6.34A7.956 7.956 0 0120 12a7.95 7.95 0 01-2.344 5.66A7.974 7.974 0 0112 20a7.97 7.97 0 01-5.657-2.34A7.953 7.953 0 014 12c0-2.059.771-3.999 2.178-5.489l.165-.17c3.118-3.12 8.194-3.122 11.313 0zm-8.142 8.853l-2.099 2.101a6.975 6.975 0 004.089 1.69 8.707 8.707 0 00-1.99-3.79zm2.485-2.486l-1.776 1.777a9.738 9.738 0 012.308 4.496 6.975 6.975 0 004.052-1.685l-4.584-4.588zm2.484-2.484L12.707 12l4.584 4.587a6.944 6.944 0 001.69-4.055 9.734 9.734 0 01-4.497-2.309zm-9.465 2.272l.013.173a6.942 6.942 0 001.678 3.918l2.099-2.1a8.72 8.72 0 00-3.79-1.991zm.013-1.163l-.01.136a9.709 9.709 0 014.496 2.31L11.292 12 6.709 7.414a6.957 6.957 0 00-1.678 3.918zM17.29 7.414l-2.098 2.1a8.752 8.752 0 003.791 1.992 6.941 6.941 0 00-1.693-4.092zM11.47 5.02l-.14.011a6.976 6.976 0 00-3.913 1.676L12 11.293l1.777-1.778a9.714 9.714 0 01-2.306-4.494h-.002zm1.027-.003l.042.17a8.734 8.734 0 001.947 3.618l2.098-2.099a6.968 6.968 0 00-4.086-1.689h-.001z",
        fill: "currentColor"
      }
    )
  ] }) });
}
export {
  h as default
};
